<template>
  <div class="detail-warpper">
    <div class="header">
      <div class="iconfont icon-fanhui2" @click="goBack"></div>
      <div class="header-text">居民详情</div>
    </div>
    <div class="content-warpper">
      <!-- 左侧用户信息 -->
      <div class="userInfo">
        <!-- 用户信息面板 -->
        <div class="userPanel">
          <div class="avastar">
            <img
              width="100%"
              height="100%"
              :src="userInfo.headPicUrl||require('@/assets/images/default.png')"
              title="头像"
            />
            <img
              class="role"
              :class="addTo"
              v-if="userInfo.isParty"
              :src="require('@/assets/images/party.png')"
              alt
            />
            <img
              :class="userInfo.isParty ? 'role1' : 'role'"
              v-if="userInfo.isVol"
              :src="require('@/assets/images/volunteer.png')"
              alt
            />
          </div>
          <div class="zanwuweixin" v-if="userInfo.noWechat">暂无绑定微信</div>
          <div class="nickName">
            <span class="iconfont icon-dangyuan" v-if="userInfo.isParty"></span>
            {{userInfo.realName||userInfo.residentName||''}}
          </div>
          <!-- 关联用户到微信按钮 仅在用户没有绑定微信的情况下显示-->
          <Button
            type="warning"
            class="bind-wechat"
            v-if="userInfo.noWechat"
            @click="onShowBindWechat"
          >关联微信</Button>
          <div class="jifen">
            <span class="jf-t">总积分</span>
            <span class="jf-c">{{userInfo.score||''}}</span>
          </div>
          <div class="jifen">
            <span class="jf-t">积分排名</span>
            <span class="jf-c">{{`${userInfo.rank || ''}/${userInfo.total || ''}`}}</span>
          </div>
          <div class="jifen">
            <span class="jf-t">总时长</span>
            <span class="jf-c">{{userInfo.timelength/3600000}}</span>
          </div>
          <div class="jifen">
            <span class="jf-t">时长排名</span>
            <span class="jf-c">{{`${userInfo.timeRank || ''}/${userInfo.timeTotal || ''}`}}</span>
          </div>
        </div>
        <!-- 审核按钮 -->
        <div class="verifyButton" v-if="userInfo.realNameStatus==-1">
          <Button type="success" small class="button pass" @click="submitBaseInfo(1)">{{passBtn}}</Button>
          <Button type="error" small class="button nopass" @click="submitBaseInfo(0)">审核不通过</Button>
        </div>
      </div>
      <!-- 右侧用户事件 -->
      <div class="userEvent">
        <Card style="height: 100%;">
          <Tabs :animated="false">
            <TabPane label="个人信息">
              <div class="base-title">
                <div class="base-title-text">基本信息</div>
                <div class="edit-box">
                  <transition name="cancel-fade">
                    <div v-show="edit" @click="exitEdit" class="edit-btn cancel">取消</div>
                  </transition>
                  <div class="edit-btn" @click="toEdit">{{edit?'保存':'编辑'}}</div>
                  <div
                    class="edit-btn"
                    style="background: #f44241"
                    v-if="userInfo.status == -1"
                    @click="shenhe(0)"
                  >审核不通过</div>
                  <div
                    class="edit-btn"
                    style="background: #47ba54"
                    v-if="userInfo.status == -1 || userInfo.status == 0"
                    @click="shenhe(1)"
                  >审核通过</div>
                </div>
              </div>
              <div class="baseInfo">
                <baseinfo
                  class="baseinfo-item"
                  v-for="(item,index) in baseinfo"
                  :edit="item.edit"
                  :ref="item.name"
                  :key="index"
                  :title="item.title"
                  :infoValue="item.infoValue"
                  :model="item.model"
                  :path="item.path"
                  :input-type="item.inputType"
                  :placeholder="item.placeholder"
                  :selectList="item.selectList"
                  :currentId="item.currentId"
                  :multiple="item.multiple"
                  :clearable="item.clearable"
                  @clearZone="clearZone"
                  @casChange="cascadeChange"
                ></baseinfo>
              </div>
              <div class="base-title">
                <div class="base-title-text">党员信息</div>
              </div>
              <div class="baseInfo">
                <baseinfo
                  class="baseinfo-item"
                  v-for="(item,index) in partyinfo"
                  :edit="item.edit"
                  :ref="item.name"
                  :key="index"
                  :title="item.title"
                  :infoValue="item.infoValue"
                  :model="item.model"
                  :input-type="item.inputType"
                  :placeholder="item.placeholder"
                  :selectList="item.selectList"
                  :currentId="item.currentId"
                  :multiple="item.multiple"
                  :clearable="item.clearable"
                  @clearZone="clearZone"
                ></baseinfo>
              </div>
              <div class="base-title">
                <div class="base-title-text">志愿者信息</div>
              </div>
              <div class="baseInfo">
                <baseinfo
                  class="baseinfo-item"
                  v-for="(item,index) in volinfo"
                  :edit="item.edit"
                  :ref="item.name"
                  :key="index"
                  :title="item.title"
                  :infoValue="item.infoValue"
                  :model="item.model"
                  :input-type="item.inputType"
                  :placeholder="item.placeholder"
                  :selectList="item.selectList"
                  :currentId="item.currentId"
                  :multiple="item.multiple"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  @clearZone="clearZone"
                ></baseinfo>
              </div>
              <div class="base-title">
                <div class="base-title-text">补充信息</div>
              </div>
              <div class="baseInfo">
                <baseinfo
                  class="baseinfo-item"
                  v-for="(item,index) in buchonginfo"
                  :edit="item.edit"
                  :ref="item.name"
                  :key="index"
                  :title="item.title"
                  :infoValue="item.infoValue"
                  :model="item.model"
                  :input-type="item.inputType"
                  :placeholder="item.placeholder"
                  :selectList="item.selectList"
                  :currentId="item.currentId"
                  :multiple="item.multiple"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  @clearZone="clearZone"
                ></baseinfo>
              </div>
            </TabPane>
            <TabPane label="积分记录">
              <div class="jfbox" :style="{width:width+'px'}">
                <div class="btn_wrap">
                  <Button
                    type="primary"
                    small
                    style="padding: 2px 20px"
                    @click="handleShowAdd"
                    class="add-btn"
                  >新增</Button>
                </div>
                <Table
                  class="table"
                  border
                  :columns="columns1"
                  :data="scoreList"
                  :loading="isTableLoading"
                ></Table>
                <div class="page">
                  <Page
                    :page-size="6"
                    :total="total"
                    :current="page"
                    @on-change="handleChangePage"
                    show-total
                  />
                </div>
              </div>
            </TabPane>
            <TabPane label="时长记录">
              <div class="jfbox" :style="{width:width+'px'}">
                <div class="btn_wrap">
                  <Button
                    type="primary"
                    small
                    class="add-btn"
                    style="padding: 2px 20px"
                    @click="showAddTime=true"
                  >新增</Button>
                </div>
                <Table
                  class="table"
                  border
                  :columns="columns2"
                  :data="timeList"
                  :loading="isTableLoading"
                ></Table>
                <div class="page">
                  <Page
                    :page-size="6"
                    :total="totalTime"
                    :current="pageTime"
                    @on-change="handleChangePageT"
                    show-total
                  />
                </div>
              </div>
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </div>
    <!-- modal 区域 -->
    <Modal v-model="showBindWechat" width="580" title="关联微信" footer-hide>
      <!-- 内容区域 -->
      <div class="wechat-code-wrapper">
        <!-- 加载中 -->
        <Spin fix v-if="bindLoading"></Spin>
        <!-- 二维码 -->
        <div class="qrcode">
          <img class="qrcode-img" :src="bindApp[appIndex].qrcodeUrl" />
        </div>
        <!-- 文字说明 -->
        <span class="description">扫码关联用户到{{bindApp[appIndex].name}}</span>
        <div class="switch-app">
          <div v-for="(item,index) in bindApp" :key="item.name" class="switch-item-wrapper">
            <div
              class="switch-item"
              :class="{active:item.show}"
              @click="switchApp(index)"
            >关联{{item.name}}</div>
            <div class="divider" v-if="index<bindApp.length-1"></div>
          </div>
        </div>
      </div>
    </Modal>
    <!-- 积分补录 -->
    <Modal
      v-model="showAddScore"
      title="新增积分"
      width="580"
      @on-ok="sendAddScore"
      @on-cancel="clearModel"
    >
      <!-- 内容区域 -->
      <div class="add-wrapper">
        <div class="add-item">
          <label class="add-label">积分来源</label>
          <RadioGroup v-model="addTo" size="large">
            <Radio label="民生通"></Radio>
            <Radio label="先锋e家"></Radio>
            <Radio label="社区云助手"></Radio>
          </RadioGroup>
        </div>
        <div class="add-item">
          <label class="add-label">积分描述</label>
          <Input class="add-input" v-model="newDiscript" placeholder="请输入积分描述" clearable />
        </div>
        <div class="add-item">
          <label class="add-label">积分分值</label>
          <Input class="add-input" v-model="newScore" placeholder="请输入积分分值" clearable />
        </div>
      </div>
      <div slot="footer">
        <Button class="add-confirm" @click="clearModel">取消</Button>
        <Button class="add-confirm" type="warning" @click="sendAddScore">确认</Button>
      </div>
    </Modal>
    <!-- 积分编辑 -->
    <Modal v-model="showEditScore" title="编辑积分" width="580">
      <!-- 内容区域 -->
      <div class="add-wrapper">
        <div class="add-item">
          <label class="add-label">积分来源</label>
          <RadioGroup v-model="addTo" size="large">
            <Radio label="民生通"></Radio>
            <Radio label="先锋e家"></Radio>
            <Radio label="社区云助手"></Radio>
          </RadioGroup>
        </div>
        <div class="add-item">
          <label class="add-label">积分描述</label>
          <Input class="add-input" v-model="newDiscript" placeholder="请输入积分描述" clearable />
        </div>
        <div class="add-item">
          <label class="add-label">积分分值</label>
          <Input class="add-input" v-model="newScore" placeholder="请输入积分分值" clearable />
        </div>
      </div>
      <div slot="footer">
        <Button class="add-confirm" @click="clearModel">取消</Button>
        <Button class="add-confirm" type="warning" @click="sendEditScore">确认</Button>
      </div>
    </Modal>
    <!-- 积分删除 -->
    <Modal v-model="delModel" width="360">
      <p slot="header" style="color:#ff7c43;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>提示</span>
      </p>
      <div style="text-align:center">
        <p>确定删除这条积分记录吗</p>
      </div>
      <div slot="footer">
        <Button type="warning" size="large" long @click="delScore">删除</Button>
      </div>
    </Modal>
    <!-- 时长补录 -->
    <Modal
      v-model="showAddTime"
      title="新增时长"
      width="580"
      @on-ok="sendAddTime"
      @on-cancel="clearModel1"
    >
      <!-- 内容区域 -->
      <div class="add-wrapper">
        <div class="add-item">
          <label class="add-label">来源</label>
          <RadioGroup v-model="addTo1" size="large">
            <Radio label="民生通"></Radio>
            <Radio label="先锋e家"></Radio>
          </RadioGroup>
        </div>
        <div class="add-item">
          <label class="add-label">描述</label>
          <Input class="add-input" v-model="timeDesc" placeholder="请输入描述" clearable />
        </div>
        <div class="add-item">
          <label class="add-label">时长</label>
          <Input class="add-input" v-model="timeLen" placeholder="请输入时长" clearable />
        </div>
      </div>
      <div slot="footer">
        <Button class="add-confirm" @click="clearModel1">取消</Button>
        <Button class="add-confirm" type="warning" @click="sendAddTime">确认</Button>
      </div>
    </Modal>
    <Modal v-model="deltime" width="360">
      <p slot="header" style="color:#ff7c43;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>提示</span>
      </p>
      <div style="text-align:center">
        <p>确定删除这条时长记录吗</p>
      </div>
      <div slot="footer">
        <Button type="warning" size="large" long @click="delTime">删除</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import baseinfo from "./components/baseInfo";
import eventcard from "./components/eventCard";
// import { constants } from "crypto";
// import { Promise, reject } from "q";
// import { userInfo } from "os";
// import { resolve } from 'dns';
var that;
export default {
  created() {
    that = this;
  },
  mounted() {
    this.width = window.innerWidth - 150 - 20 * 3 - 392 - 32; //表格区域宽度
    let that = this;
    window.onresize = () => {
      return (() => {
        that.width = window.innerWidth - 150 - 20 * 3 - 392 - 32;
      })();
    };
    //如果从组织进来的 组织标识isorg变1  审核通过按钮字改变
    if (this.$route.params.isOrg) {
      this.isOrg = 1;
      this.passBtn = "审核通过并加入组织";
      this.peopleIdByOrg = this.$route.params.peopleid;
    }
    this.unionId = this.$route.params.unionId || sessionStorage.userUnionId; // 刷新时读取
    this.communityId =
      this.$route.params.communityId || sessionStorage.communityId;
    sessionStorage.communityId = this.communityId; // 存储 communityId
    sessionStorage.userUnionId = this.unionId; // 第一进来 存储unionid

    this.getDetail(); // 获取剧名详情
    this.getAllList();
    this.getScoreList();
    this.getTimeList();
    this.getVolItem();
    // this.getAuthDetail();
  },
  data() {
    return {
      width: 0,
      isOrg: 0, //是否从组织进来
      passBtn: "审核通过",
      peopleIdByOrg: "", //组织对应的人员id
      communityId: "",
      userInfo: {},
      unionId: "",
      bindLoading: false,
      showBindWechat: false, // 是否显示绑定微信
      appIndex: 0, // 显示哪个小程序的二维码
      appName: "", // 绑定到小程序的名称
      bindApp: [{}], // 要绑定的小程序列表
      qrCodeList: [], // 绑定微信的二维码
      edit: false, // 控制 本组件的编辑模式
      eventList: {
        header: "参加活动",
        number: "0",
        dataList: []
      },
      scoreList: [],
      showAddScore: false,
      showAddTime: false,
      newScore: "",
      newDiscript: "",
      addTo: "",
      addTo1: "",
      delModel: false,
      deltime: false,
      delIndex: "",
      editIndex: "",
      delIndex1: "",
      editIndex1: "",
      showEditScore: false,
      authDetailList: [],
      rStatus: null,
      isTableLoading: false,
      communityInfo: [],
      columns1: [
        {
          title: "小程序",
          key: "from"
        },
        {
          title: "积分来源",
          key: "remark",
          width: 450
        },
        {
          title: "积分",
          key: "score"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: () => {
                      that.showEditModel(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      that.showDelModel(params.index);
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        }
      ],
      columns2: [
        {
          title: "小程序",
          key: "from"
        },
        {
          title: "描述",
          key: "remark",
          width: 450
        },
        {
          title: "时长（小时）",
          key: "time",
          className: "timelength"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: () => {
                      // that.showEditModel(params.index);
                      that.showEditTime(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: () => {
                      that.showDelTime(params.index);
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        }
      ],
      page: 1,
      total: 0,
      pageTime: 1,
      totalTime: 0,
      baseinfo: [],
      selectedId: "",
      partyinfo: [],
      volinfo: [],
      buchonginfo: [],
      party: true,
      volunteer: true,
      timeArr: [
        { id: 1, label: "周一上午", value: "1,am" },
        { id: 1, label: "周一下午", value: "1,pm" },
        { id: 1, label: "周一晚上", value: "1,nt" },
        { id: 2, label: "周二上午", value: "2,am" },
        { id: 2, label: "周二下午", value: "2,pm" },
        { id: 3, label: "周二晚上", value: "2,nt" },
        { id: 3, label: "周三上午", value: "3,am" },
        { id: 3, label: "周三下午", value: "3,pm" },
        { id: 3, label: "周三晚上", value: "3,nt" },
        { id: 4, label: "周四上午", value: "4,am" },
        { id: 4, label: "周四下午", value: "4,pm" },
        { id: 4, label: "周四晚上", value: "4,nt" },
        { id: 5, label: "周五上午", value: "5,am" },
        { id: 5, label: "周五下午", value: "5,pm" },
        { id: 5, label: "周五晚上", value: "5,nt" },
        { id: 6, label: "周六上午", value: "6,am" },
        { id: 6, label: "周六下午", value: "6,pm" },
        { id: 6, label: "周六晚上", value: "6,nt" },
        { id: 0, label: "周日上午", value: "0,am" },
        { id: 0, label: "周日下午", value: "0,pm" },
        { id: 0, label: "周日晚上", value: "0,nt" }
      ],
      loading: false,
      status: null,
      timeList: [],
      timeDesc: "",
      timeLen: ""
    };
  },
  methods: {
    async clearZone(data) {
      let url = this.urlobj.deleteUserZone(this.unionId);
      url += "?zoneIdList=" + data.id;
      try {
        let result = await this.$delete(url, {});
        this.$Message.success("操作成功");
        if (result) {
          this.getDetail();
          this.getAuthDetail();
        }
        let type = data.title == "微支部" ? "org" : "community";
      } catch (e) {
        console.log(e);
      }

      //清除绑定的微社区，微支部
    },
    /* 返回 */
    goBack() {
      this.$router.go(-1);
    },
    cascadeChange(value) {
      this.selectedId = value;
      console.log(this.selectedId);
    },
    getAdminRegion(baseinfo, info) {
      let index = -1;
      baseinfo.forEach((item, i) => {
        if (item.fieldValue == "community_name") {
          index = i;
        }
      });
      baseinfo.splice(index, 1);
      console.log("info", info);
      baseinfo.push({
        name: info.fieldValue,
        title: info.fieldName,
        multiple: false,
        edit: false,
        infoValue:
          info.dataValue && info.dataValue.length
            ? info.dataValue[0].value
            : "暂无数据",
        path:
          info.dataValue && info.dataValue.length
            ? info.dataValue[0].pathLine
            : [],
        model: "cascader",
        placeholder: "请选择行政区域",
        inputtype: info.inputType
      });
    },
    /* 获取市民详情 */
    getDetail() {
      this.loading = true;
      var url = this.urlobj.residentDetail;
      var data = {
        unionId: this.unionId,
        communityId: this.communityId
      };
      this.$get(url, data).then(res => {
        var data1 = res.rows[0];
        this.userInfo = {
          headPicUrl: data1.headPicUrl,
          realName: data1.realName,
          score: data1.contribution.score / 100,
          rank: data1.contribution.rank,
          total: data1.contribution.total,
          noWechat: this.unionId.indexOf("jczl_") == -1 ? false : true,
          isParty: data1.roleIdList.indexOf(2) == -1 ? false : true,
          isVol: data1.roleIdList.indexOf(17) == -1 ? false : true,
          status: data1.status,
          timelength: data1.timeLength.timeLength
            ? data1.timeLength.timeLength
            : "0",
          timeTotal: data1.timeLength.total,
          timeRank: data1.timeLength.rank
        };
        this.loading = false;
      });
    },
    /* 获取实名认证配置详情 */
    getAuthDetail(status) {
      this.loading = true;
      var url = this.urlobj.getAuth("resident");
      var data = {
        unionId: this.unionId,
        communityId: this.communityId
      };
      this.$get(url, data).then(res => {
        var baseinfo = [];
        var partyinfo = [];
        var volinfo = [];
        var buchonginfo = [];
        /**基本信息表单处理 */
        res.rows.forEach(item => {
          // console.log(res.rows);
          if (item.fieldValue == "community_name") {
            this.communityInfo = item;
          }
          if (item.fieldType == 1) {
            if (item.inputType == 0) {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                edit: false,
                infoValue: item.dataValue ? item.dataValue : "",
                inputtype: item.inputType,
                model: "input",
                placeholder: "请输入"
              });
            }
            if (item.inputType == 1) {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                multiple: false,
                edit: false,
                infoValue:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].value
                    : "暂无数据",
                model: "select",
                placeholder: "请选择",
                currentId:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].id
                    : "",
                selectList: this.community,
                inputtype: item.inputType,
                clearable: this.userInfo.status == 1 ? true : false
              });
            }
            if (item.fieldValue == "rnf_religion") {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                multiple: false,
                edit: false,
                infoValue:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].value
                    : "暂无数据",
                model: "select",
                placeholder: "请选择",
                currentId:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].id
                    : "",
                selectList: this.religion,
                inputtype: item.inputType
              });
            }
            if (item.fieldValue == "rnf_national") {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                multiple: false,
                edit: false,
                infoValue:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].value
                    : "暂无数据",
                model: "select",
                placeholder: "请选择",
                currentId:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].id
                    : "",
                selectList: this.national,
                inputtype: item.inputType
              });
            }
            if (item.inputType == 2) {
              if (!item.dataValue) return;
              var role = item.dataValue.map(_item => {
                return _item.id;
              });
            }
          }
        });
        if(this.$store.state.apptype == 'ipy') {
          this.getAdminRegion(baseinfo, this.communityInfo);
        }
        /**基本信息表单处理结束 */
        /**党员信息表单处理 */
        var partyinfo1 = res.rows.filter(item => item.fieldType == 4);
        partyinfo1.forEach(item => {
          if (item.inputType == 1) {
            if (item.fieldValue == "party_name") {
              // console.log(item);
            }
            partyinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: false,
              edit: false,
              infoValue:
                item.dataValue && item.dataValue.length
                  ? item.dataValue[0].value
                  : "暂无数据",
              model: "select",
              placeholder: "请选择",
              currentId:
                item.dataValue && item.dataValue.length
                  ? item.dataValue[0].id
                  : "",
              selectList: this.org,
              inputtype: item.inputType,
              clearable: this.userInfo.status == 1 ? true : false
            });
          }
          if (item.inputType == 0) {
            partyinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              edit: false,
              infoValue: item.dataValue ? item.dataValue : "",
              inputtype: item.inputType,
              model: "input",
              placeholder: "请输入"
            });
          }
        });
        /**党员信息表单处理结束 */
        /**志愿者信息表单处理 */
        var volinfo1 = res.rows.filter(item => item.fieldType == 5);
        volinfo1.forEach(item => {
          if (item.fieldValue == "speciality") {
            var spec = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.value;
                })
              : [];
            var idl = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.id;
                })
              : [];
            volinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: true,
              edit: false,
              infoValue: item.dataValue ? spec.join(",") : "",
              model: "select",
              placeholder: "请选择",
              fieldValue: item.fieldValue,
              inputtype: item.inputType,
              currentId: item.dataValue ? idl : [],
              selectList: this.speciality
            });
          }
          if (item.fieldValue == "services_items") {
            var spec = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.value;
                })
              : [];
            var idl = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.id;
                })
              : [];
            volinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: true,
              edit: false,
              infoValue: item.dataValue ? spec.join(",") : "",
              model: "select",
              placeholder: "请选择",
              fieldValue: item.fieldValue,
              inputtype: item.inputType,
              currentId: item.dataValue ? idl : [],
              selectList: this.volItem
            });
          }
          if (item.fieldValue == "services_hours") {
            var spec = item.dataValue
              ? item.dataValue.map(_item => {
                  return {
                    id: _item.id,
                    date: this.initDate(_item.id),
                    value: _item.value.split(",")
                  };
                })
              : [];
            var date = [];
            spec.forEach(_item => {
              _item.value.forEach(item1 => {
                date.push({
                  date:
                    _item.date +
                    (item1 == "am" ? "上午" : item1 == "pm" ? "下午" : "晚上"),
                  val: _item.id + "," + item1
                });
              });
            });
            volinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: true,
              edit: false,
              infoValue: item.dataValue
                ? date
                    .map(_item => {
                      return _item.date;
                    })
                    .join(",")
                : "",
              model: "select",
              placeholder: "请选择",
              fieldValue: item.fieldValue,
              inputtype: item.inputType,
              currentId: item.dataValue
                ? date.map(_item => {
                    return _item.val;
                  })
                : [],
              selectList: this.timeArr
            });
          }
          if (item.fieldValue == "volunteer_org") {
            var spec = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.value;
                })
              : [];
            var idl = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.id;
                })
              : [];
            volinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: true,
              edit: false,
              infoValue: item.dataValue ? spec.join(",") : "",
              model: "select",
              placeholder: "请选择",
              fieldValue: item.fieldValue,
              inputtype: item.inputType,
              currentId: item.dataValue ? idl : [],
              selectList: this.organize
            });
          }
          if (item.inputType == 0) {
            volinfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              edit: false,
              infoValue: item.dataValue ? item.dataValue : "",
              inputtype: item.inputType,
              model: "input",
              placeholder: "请输入"
            });
          }
        });
        /**志愿者信息表单处理结束 */
        /**补充信息表单处理 */
        var bcinfo = res.rows.filter(item => item.fieldType == 2);
        bcinfo.forEach(item => {
          if (item.inputType == 0) {
            buchonginfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              edit: false,
              infoValue: item.dataValue ? item.dataValue : "",
              inputtype: item.inputType,
              model: "input",
              placeholder: "请输入"
            });
          }
          if (item.inputType == 3) {
            var spec = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.value;
                })
              : [];
            var idl = item.dataValue
              ? item.dataValue.map(_item => {
                  return _item.id;
                })
              : [];
            buchonginfo.push({
              name: item.fieldValue,
              title: item.fieldName,
              multiple: true,
              edit: false,
              infoValue: item.dataValue ? spec.join(",") : "",
              inputtype: item.inputType,
              model: "select",
              placeholder: "请选择",
              currentId: item.dataValue ? idl : [],
              selectList: this.hobby
            });
          }
        });
        /**补充信息表单处理结束 */
        this.partyinfo = partyinfo;
        this.baseinfo = baseinfo;
        this.volinfo = volinfo;
        this.buchonginfo = buchonginfo;
        this.loading = false;
      });
    },
    initDate(id) {
      switch (id) {
        case 1:
          return "周一";
          break;
        case 2:
          return "周二";
          break;
        case 3:
          return "周三";
          break;
        case 4:
          return "周四";
          break;
        case 5:
          return "周五";
          break;
        case 6:
          return "周六";
          break;
        case 0:
          return "周日";
          break;
      }
    },
    initValue(list) {
      var arr = list.map(item => {
        return item.split(",");
      });
      var arr1 = [];
      for (let i = 0; i <= 6; i++) {
        arr1.push(this.filtValue(i, arr));
      }
      var arr2 = [];
      arr1.forEach(item => {
        if (item.value.length) {
          arr2.push({
            id: item.id,
            value: item.value.join(",")
          });
        }
      });
      return arr2;
    },
    filtValue(id, list) {
      let arr = list.filter(item => item[0] == id);
      let obj = {
        id,
        value: []
      };
      for (let i = 0; i < arr.length; i++) {
        obj.value.push(arr[i][1]);
      }
      return obj;
    },
    /**获取所有下拉列表 */
    getAllList() {
      this.loading = true;
      var getOrgList = this.getOrgList();
      var getHobbyList = this.getHobbyList();
      var getSpecialityList = this.getSpecialityList();
      var getVolItem = this.getVolItem();
      var getOrganize = this.getOrganize();
      var getReligionList = this.getReligionList();
      var getNationalList = this.getNationalList();
      Promise.all([
        getOrgList,
        getHobbyList,
        getSpecialityList,
        getVolItem,
        getOrganize,
        getReligionList,
        getNationalList
      ]).then(res => {
        /**微社区和微支部列表begin */
        let _org = res[0].rows.filter(
          item => item.zoneType == 2 || item.zoneType == 0
        );
        let _com = res[0].rows.filter(item => item.zoneType == 1);
        this.org = _org.map(item => {
          return {
            value: item.zoneId,
            label: item.zoneName
          };
        });
        this.community = _com.map(item => {
          return {
            value: item.zoneId,
            label: item.zoneName
          };
        });
        /**微社区和微支部列表end */
        /**兴趣爱好列表begin */
        if (res[1].rows.length) {
          this.hobby = res[1].rows.map(item => {
            return {
              label: item.dicName,
              value: item.id.toString() // 为了 匹配select组件的 value 严格匹配 string 类型
            };
          });
        }
        /**兴趣爱好列表end */
        /**服务特长列表begin */
        if (res[2].rows.length) {
          this.speciality = res[2].rows.map(item => {
            return {
              label: item.dicName,
              value: item.id
            };
          });
        }
        /**服务特长列表end */
        /**志愿服务项目列表begin */
        if (res[3].rows.length) {
          this.volItem = res[3].rows.map(item => {
            return {
              label: item.dicName,
              value: item.id
            };
          });
        }
        /**志愿服务项目列表end */
        /**志愿组织列表begin */
        this.organize = res[4].rows.map(item => {
          return {
            label: item.orgName,
            value: item.id // 为了 匹配select组件的 value 严格匹配 string 类型
          };
        });
        /**志愿组织列表end */
        /**宗教信仰列表begin */
        this.religion = res[5].rows.map(item => {
          return {
            label: item.dicName,
            value: item.id // 为了 匹配select组件的 value 严格匹配 string 类型
          };
        });
        /**宗教信仰列表end */
        /**民族分类列表begin */
        this.national = res[6].rows.map(item => {
          return {
            label: item.dicName,
            value: item.id // 为了 匹配select组件的 value 严格匹配 string 类型
          };
        });
        /**民族分类列表end */
        this.getAuthDetail();
      });
    },
    /* 获取微支部微社区选择列表 */
    getOrgList() {
      let url = this.urlobj.getOrg();
      return new Promise((resolve, reject) => {
        this.$get(url, {
          zoneType: -1,
          // isAddCommunity: 1,
          communityId: this.communityId
        })
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    /* 获取兴趣爱好字典 */
    getHobbyList() {
      let url = this.urlobj.dictionaryList("hobby");
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    /* 获取服务特长字典 */
    getSpecialityList() {
      let url = this.urlobj.dictionaryList("speciality");
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    /* 获取志愿服务项目字典 */
    getVolItem() {
      let url = this.urlobj.dictionaryList("services_items");
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    getOrganize() {
      var url = this.urlobj.getOrgList;
      var data = {
        pageNum: 1,
        pageSize: 999,
        comeType: 17,
        communityId: this.communityId
      };
      return new Promise((resolve, reject) => {
        this.$post(url, data)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    /* 获取宗教信仰字典 */
    getReligionList() {
      let url = this.urlobj.dictionaryList("religion");
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    /* 获取民族分类字典 */
    getNationalList() {
      let url = this.urlobj.dictionaryList("national");
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res);
          })
          .catch(e => console.log(e));
      });
    },
    /* 进入编辑模式 */
    toEdit() {
      /* 判断之前的模式 如果在编辑模式则是保存操作*/
      if (this.edit) {
        this.submitBaseInfo();
      } else {
        /* 不是编辑模式 进入编辑模式 */
        this.edit = true;
        /* 每个对象都进去编辑模式 */
        // this.baseinfo = this.baseinfo.map(item=>{
        //   item.edit = true
        //   return item
        // })
        this.baseinfo.forEach(item => {
          item.edit = true;
        });
        this.partyinfo.forEach(item => {
          item.edit = true;
        });
        this.volinfo.forEach(item => {
          item.edit = true;
        });
        this.buchonginfo.forEach(item => {
          item.edit = true;
        });
      }
    },
    /* 退出编辑模式 */
    exitEdit() {
      this.edit = false;
      /* 每个对象都退出编辑模式 */
      this.baseinfo.forEach(item => {
        item.edit = false;
      });
      this.partyinfo.forEach(item => {
        item.edit = false;
      });
      this.volinfo.forEach(item => {
        item.edit = false;
      });
      this.buchonginfo.forEach(item => {
        item.edit = false;
      });
    },
    /* 提交基本信息 */
    submitBaseInfo(state) {
      this.loading = true;
      /**处理表单数据 */
      var baseInfo = this.baseinfo.map(item => {
        let name = item.name;
        if (item.inputtype == 0) {
          item.dataValue = this.$refs[name][0].getValue() || "";
        }
        if (item.inputtype == 1 || item.inputtype == 6) {
          item.dataValue = this.$refs[name][0].getSelectedId() || "";
        }
        return item;
      });
      var partyInfo = this.partyinfo.map(item => {
        let name = item.name;
        if (item.inputtype == 0) {
          item.dataValue = this.$refs[name][0].getValue() || "";
        }
        if (item.inputtype == 1) {
          item.dataValue = this.$refs[name][0].getSelectedId() || "";
        }
        return item;
      });
      var volInfo = this.volinfo.map(item => {
        let name = item.name;
        if (item.inputtype == 0) {
          item.dataValue = this.$refs[name][0].getValue() || "";
        }
        if (item.inputtype == 3 || item.inputtype == 4) {
          item.dataValue = this.$refs[name][0].getSelectedId() || [];
        }
        if (item.inputtype == 5) {
          console.log("zhiyuan");
          item.dataValue = this.$refs[name][0].getSelectedId() || [];
        }
        return item;
      });
      var bcInfo = this.buchonginfo.map(item => {
        let name = item.name;
        if (item.inputtype == 0) {
          item.dataValue = this.$refs[name][0].getValue() || "";
        }
        if (item.inputtype == 3) {
          item.dataValue = this.$refs[name][0].getSelectedId() || "";
        }
        return item;
      });
      // console.log(bcInfo)
      let data1 = [],
        data2 = [],
        data3 = [],
        data4 = [];
      baseInfo.forEach(item => {
        if (item.inputtype == 0) {
          data1.push({
            fieldValue: item.name,
            dataValue: item.dataValue
          });
        }
        if (item.inputtype == 1 || item.inputtype == 6) {
          data1.push({
            fieldValue: item.name,
            dataValue: item.dataValue ? [{ id: item.dataValue }] : []
          });
        }
      });
      partyInfo.forEach(item => {
        if (item.inputtype == 0) {
          data2.push({
            fieldValue: item.name,
            dataValue: item.dataValue
          });
        }
        if (item.inputtype == 1) {
          data2.push({
            fieldValue: item.name,
            dataValue: item.dataValue ? [{ id: item.dataValue }] : []
          });
        }
      });
      volInfo.forEach(item => {
        if (item.inputtype == 0) {
          data3.push({
            fieldValue: item.name,
            dataValue: item.dataValue
          });
        }
        if (item.inputtype == 3 || item.inputtype == 5) {
          data3.push({
            fieldValue: item.name,
            dataValue: item.dataValue
              ? item.dataValue.map(_item => {
                  return { id: _item };
                })
              : []
          });
        }
        if (item.inputtype == 4) {
          data3.push({
            fieldValue: item.name,
            dataValue: item.dataValue ? this.initValue(item.dataValue) : []
          });
        }
      });
      bcInfo.forEach(item => {
        if (item.inputtype == 0) {
          data4.push({
            fieldValue: item.name,
            dataValue: item.dataValue
          });
        }
        if (item.inputtype == 3) {
          data4.push({
            fieldValue: item.name,
            dataValue: item.dataValue
              ? item.dataValue.map(_item => {
                  return { id: _item };
                })
              : []
          });
        }
      });
      let data = {
        unionId: this.unionId,
        communityId: this.communityId,
        fieldData: [...data1, ...data2, ...data3, ...data4]
      };
      if(this.$store.state.apptype == 'ipy') {
        let index;
        data.fieldData.forEach((item, i) => {
          if (item.fieldValue == "community_name") {
            index = i;
          }
        });
        console.log("index",index)
        data.fieldData[index].dataValue = [{ id: this.selectedId }];
      }
     
      this.$post(this.urlobj.applyRealname("resident"), data)
        .then(res => {
          this.$Message.success("操作成功");
          this.getDetail();
          this.getAuthDetail();
          this.exitEdit();
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
      console.log(data);
      return;
    },
    shenhe(status) {
      let url = this.urlobj.shenheAll("resident");
      let data = {
        status,
        unionIds: this.unionId,
        communityId: this.communityId
      };
      this.$post(url, data).then(res => {
        this.$Message.success("操作成功");
        this.getDetail();
        this.getAuthDetail();
        this.exitEdit();
      });
    },
    //组织审核通过
    OrgPass(status) {
      var url = this.urlobj.orgShenhe;
      this.$post(url, {
        id: this.peopleIdByOrg, // org2user对象ID,
        status //1为审核通过，0为审核不过
      }).then(res => {
        this.passBtn = "审核通过"; //审核通过按钮复原
      });
    },
    /* 设置用户 baseinfo */
    _initBaseInfoObj(obj, prop, value) {
      if (prop) {
        this.baseInfoObj[obj][prop] = value;
      } else {
        this.baseInfoObj[obj] = value;
      }
    },
    /* 显示绑定微信弹框 */
    onShowBindWechat() {
      this.showBindWechat = true; // 显示模态框

      // 第一次点击时加载 如果有数据不加载
      if (!this._.isEmpty(this.bindApp[0])) return;

      this.bindLoading = true; // 显示loading
      let url = this.urlobj.bindQrcode;
      this.$get(url, {
        unionId: this.unionId
      })
        .then(res => {
          this.bindLoading = false; // 关闭loading
          let matchName = function(type) {
            switch (type) {
              case "mst":
                return "民生通";
              case "xfej":
                return "先锋e家";
            }
          };
          this.bindApp = res.rows.map(item => {
            return {
              name: matchName(item.appType),
              qrcodeUrl: item.qrcodeUrl,
              show: false
            };
          });
          // 默认第一个显示
          this.bindApp[0].show = true;
        })
        .catch(e => {
          this.bindLoading = false;
        });
    },
    /* 绑定微信 */
    switchApp(index) {
      this.appIndex = index;
      // 关闭所有
      for (const app of this.bindApp) {
        app.show = false;
      }
      // 显示当前
      this.bindApp[this.appIndex].show = true;
    },
    getScoreList() {
      let url = this.urlobj.getScoreList();
      this.isTableLoading = true;
      this.$get(url, {
        unionId: this.unionId,
        pageNum: this.page,
        pageSize: 6,
        communityId: this.communityId
      }).then(res => {
        this.isTableLoading = false;
        let list = res.rows;
        let from = "";
        list.forEach((item, index) => {
          switch (item.appType) {
            case "mst":
              from = "民生通";
              break;
            case "xfej":
              from = "先锋e家";
              break;
            case "sqyzs":
              from = "社区云助手";
              break;
            case "pc":
              from = "PC";
          }
          // console.log(item)
          item.from = from;
          item.index = index;
          item.score = item.score / 100;
        });
        this.scoreList = list;
        this.total = res.total;
      });
    },
    handleChangePage(val) {
      console.log(`第${val}页`);
      this.page = val;
      this.getScoreList();
    },
    handleChangePageT(val) {
      console.log(`第${val}页`);
      this.pageTime = val;
      this.getTimeList();
    },
    handleShowAdd() {
      this.showAddScore = true;
    },
    sendAddScore() {
      let url = this.urlobj.sendAddScore();
      let appType = "";
      switch (this.addTo) {
        case "民生通":
          appType = "mst";
          break;
        case "先锋e家":
          appType = "xfej";
          break;
        case "社区云助手":
          appType = "sqyzs";
      }
      if (this.addTo == "") {
        this.$Message.warning("请选择积分来源");
        // this.showAddScore = true;
        return;
      }
      if (this.newScore == "") {
        this.$Message.warning("请输入积分分值");
        // this.showAddScore = true;
        return;
      }
      if (this.newDiscript == "") {
        this.$Message.warning("请输入积分描述");
        // this.showAddScore = true;
        return;
      }
      let data = {
        appType,
        score: this.newScore * 100,
        remark: this.newDiscript,
        unionId: this.unionId
      };
      this.$post(url, data).then(res => {
        this.getScoreList();
        this.newScore = "";
        this.newDiscript = "";
        this.addTo = "";
        this.$Message.success("添加成功");
        this.showAddScore = false;
        this.getDetail();
      });
    },
    delScore(id) {
      let delObj = this.scoreList[this.delIndex];
      let url = this.urlobj.delScore(delObj.id);
      this.$delete(url).then(res => {
        this.getScoreList();
        this.$Message.success("删除成功");
        this.delIndex = "";
        this.delModel = false;
        this.getDetail();
      });
    },
    showDelModel(index) {
      this.delIndex = index;
      this.delModel = true;
    },
    showEditModel(index) {
      this.editIndex = index;
      if (this.scoreList[index].scoreType != "patch_score") {
        this.$Message.warning("只能编辑补录的积分");
        return;
      }
      this.newScore = this.scoreList[index].score;
      this.newDiscript = this.scoreList[index].remark;
      switch (this.scoreList[index].appType) {
        case "mst":
          this.addTo = "民生通";
          break;
        case "xfej":
          this.addTo = "先锋e家";
          break;
        case "sqyzs":
          this.addTo = "社区云助手";
      }
      this.showEditScore = true;
    },
    sendEditScore() {
      let url = this.urlobj.sendAddScore();
      let appType = "";
      switch (this.addTo) {
        case "民生通":
          appType = "mst";
          break;
        case "先锋e家":
          appType = "xfej";
          break;
        case "社区云助手":
          appType = "sqyzs";
      }
      if (this.addTo == "") {
        this.$Message.warning("请选择积分来源");
        return;
      }
      if (this.newScore == "") {
        this.$Message.warning("请输入积分分值");
        return;
      }
      if (this.newDiscript == "") {
        this.$Message.warning("请输入积分描述");
        return;
      }
      let editObj = this.scoreList[this.editIndex];
      let data = {
        appType,
        score: this.newScore * 100,
        remark: this.newDiscript,
        unionId: this.unionId,
        id: editObj.id
      };
      this.$post(url, data).then(res => {
        this.getScoreList();
        this.newScore = "";
        this.newDiscript = "";
        this.addTo = "";
        this.editIndex = "";
        this.$Message.success("编辑成功");
        this.showEditScore = false;
      });
    },
    clearModel() {
      this.newScore = "";
      this.newDiscript = "";
      this.addTo = "";
      this.delIndex = "";
      this.editIndex = "";
    },
    getTimeList() {
      this.isTableLoading = true;
      var url = this.urlobj.timelengthList;
      var data = {
        unionId: this.unionId,
        pageNum: this.pageTime,
        pageSize: 6,
        communityId: this.communityId
      };
      this.$post(url, data)
        .then(res => {
          var list = res.rows.map(item => {
            return {
              id: item.id,
              from:
                item.appType == "mst"
                  ? "民生通"
                  : item.appType == "xfej"
                  ? "先锋e家"
                  : "",
              remark:
                item.timeLengthType == "patch"
                  ? item.remark + "（补录）"
                  : item.remark,
              time: item.timeLength / 3600 / 1000,
              type: item.timeLengthType
            };
          });
          this.totalTime = res.total;
          this.timeList = list;
          this.isTableLoading = false;
        })
        .catch(e => (this.isTableLoading = false));
    },
    sendAddTime() {
      let url = this.urlobj.addTimeLength;
      let appType = "";
      switch (this.addTo1) {
        case "民生通":
          appType = "mst";
          break;
        case "先锋e家":
          appType = "xfej";
          break;
      }
      if (this.addTo1 == "") {
        this.$Message.warning("请选择来源");
        // this.showAddScore = true;
        return;
      }
      if (this.timeLen == "") {
        this.$Message.warning("请输入时长");
        // this.showAddScore = true;
        return;
      }
      if (this.timeDesc == "") {
        this.$Message.warning("请输入描述");
        // this.showAddScore = true;
        return;
      }
      let data = {
        unionId: this.unionId,
        communityId: this.communityId,
        appType,
        timeLength: this.timeLen * 3600 * 1000,
        remark: this.timeDesc
      };
      if (this.timeList[this.editIndex1]) {
        data.id = this.timeList[this.editIndex1].id;
      }
      this.$post(url, data).then(res => {
        this.getTimeList();
        this.timeLen = "";
        this.timeDesc = "";
        this.addTo1 = "";
        this.$Message.success("添加成功");
        this.showAddTime = false;
        this.getDetail();
      });
    },
    showEditTime(index) {
      this.editIndex1 = index;
      if (this.timeList[index].type != "patch") {
        this.$Message.warning("只能编辑补录的时长");
        return;
      }
      var ind = this.timeList[index].remark.indexOf("（");
      this.timeLen = this.timeList[index].time;
      this.timeDesc = this.timeList[index].remark.substring(0, ind);
      this.addTo1 = this.timeList[index].from;
      this.showAddTime = true;
    },
    delTime(id) {
      let delObj = this.timeList[this.delIndex1];
      let url = this.urlobj.delTimeLength(delObj.id);
      this.$delete(url).then(res => {
        this.getTimeList();
        this.$Message.success("删除成功");
        this.delIndex1 = "";
        this.deltime = false;
        this.getDetail();
      });
    },
    showDelTime(index) {
      this.delIndex1 = index;
      this.deltime = true;
    },
    clearModel1() {
      this.timeLen = "";
      this.timeDesc = "";
      this.addTo1 = "";
      this.delIndex1 = "";
      this.editIndex1 = "";
      this.showAddTime = false;
    }
  },
  computed: {
    baseInfo() {
      return this.$util.mapObj(this.baseInfoObj, item => item);
    }
  },
  watch: {},
  components: {
    baseinfo,
    eventcard
  }
};
</script>

<style lang='less' scoped>
/* -----------------------------积分补录对话框-------------------------------- */
.add-wrapper {
  min-height: 360px;
}
.add-item {
  display: flex;
  align-items: center;
}
.add-label {
  min-width: 4em;
  white-space: nowrap;
  text-align: right;
  font-size: 18px;
  color: #666;
  margin: 15px 10px 15px 0;
}
.add-input {
  flex: 1;
}
/* -----------------------------积分补录-------------------------------- */
.content-all {
  height: 290px;
}
.gray {
  background-color: #f9f9f9;
}
.gray,
.white {
  width: 100%;
  padding-left: 15px;
}
.title-text {
  font-size: 20px;
  margin-left: 20px;
}
.title-button {
  margin-top: -5px;
  margin-right: 20px;
}
.score-content {
  height: 50px;
  // line-height: 20px;
  font-size: 18px;
  // margin-right: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.app-type {
  display: inline-block;
  line-height: 50px;
  width: 100px;
  color: #9f9f9f;
}
.jf-edit .ivu-scroll-loader {
  margin-top: -10px;
}
.score-event {
  display: inline-block;
  // width: 840px;
  line-height: 50px;
  // height: 18px;
  color: #333;
  .score-bulu {
    color: #ff9267;
  }
}
.score-number {
  display: inline-block;
  width: 70px;
  color: #fe7d43;
  line-height: 50px;
}
.icon-bianji {
  color: #bbb;
  font-size: 18px;
  margin-right: 18px;
  line-height: 50px;
}
.icon-bianji:hover {
  color: #5571b5;
}
.icon-shanchu {
  color: #bbb;
  font-size: 18px;
  line-height: 50px;
  // margin-top: 2px;
}
.icon-shanchu:hover {
  color: #f3403e;
}
.mb20 {
  margin-bottom: 18px;
}
.mb30 {
  margin-bottom: 22px;
}

.detail-warpper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* 头部标题 */
.header {
  width: 98%;
  margin: 30px auto;
  display: grid;
  grid-template-columns: 30px auto 30px;
  font-size: 25px;
  color: #666;
  .header-text {
    justify-self: center;
    align-self: center;
  }
  .icon-fanhui2 {
    font-size: 25px;
    color: #666;
    justify-self: center;
    align-self: center;
    cursor: pointer;
  }
}

/* -----------------------------市民详情-------------------------------- */
.content-warpper {
  // width: 98%;
  // margin: 0 auto;
  margin: 0 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  height: 100%;
  // flex-wrap: nowrap;
}
/* =========== 用户信息框 ==========*/
.content-item {
  border: 1px solid #ddd;
  border-radius: 4px;
}
.userInfo {
  position: relative;
  min-width: 392px;
  max-width: 392px;
  margin-right: 20px;
  background-color: #fff;
  height: 100%;
  // 保证自适应之后的边距
  .content-item;
}
/* 编辑按钮 */
.edit-box {
  display: flex;
  align-items: center;
}
.edit-btn {
  height: 28px;
  line-height: 28px;
  width: 90px;
  text-align: center;
  background-color: #ff7b43;
  border-radius: 4px;
  color: #fff;
  margin-left: 20px;
  cursor: pointer;
}
/* 取消按钮 */
.cancel {
  margin-left: 10px;
  background-color: transparent;
  color: #333;
}
/* 过渡动画 */
.cancel-fade-enter-active,
.cancel-fade-leave-active {
  transition: opacity 0.5s;
}
.cancel-fade-enter,
.cancel-fade-leave-to {
  opacity: 0;
}
.userPanel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  .avastar {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    position: relative;
    border: 1px solid #ccc;
    .mb20;
    & > img {
      border-radius: 100%;
    }
    .role {
      position: absolute;
      bottom: 0;
      right: 6px;
      width: 28px;
      height: 28px;
    }
    .role1 {
      position: absolute;
      bottom: 0;
      right: -12px;
      width: 28px;
      height: 28px;
    }
  }
  .nickName {
    font-size: 16px;
    color: #999;
    .icon-dangyuan {
      color: #e40203;
    }
    .mb20;
  }
  .authState {
    display: flex;
    align-items: center;
    border: 1px solid #333;
    padding: 2px 10px;
    border-radius: 15px;
    .mb30;
  }
  .noAuth {
    border-color: #a3aeb2;
    color: #a3aeb2;
  }
  /* 未认证的图标 */
  .noAuthIcon {
    position: relative;
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #a3aeb2;
    &::after {
      content: "...";
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translateX(-50%);
      line-height: 0;
      color: #fff;
    }
  }
  .authingIcon {
    background-color: #ff7b43;
  }
  .authed {
    color: #47b804;
    border-color: #47b804;
  }
  .authFail {
    color: #ff7b43;
    border-color: #ff7b43;
  }
  .auth-text {
    margin-left: 10px;
  }
}
/* 绑定微信 */
.bind-wechat {
  background-color: #ff7b43;
  line-height: 1;
}
.wechat-code-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 16px;
  color: #999;

  padding: 40px;
  .qrcode-img {
    width: 175px;
    height: 175px;
  }
  .description {
    margin: 10px 0 40px 0;
  }
}
.switch-app {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 40px 80px 0 80px;
  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background: #eee;
    background: linear-gradient(
      to right,
      rgba(238, 238, 238, 0.2),
      rgba(238, 238, 238, 1),
      rgba(238, 238, 238, 0.2)
    );
  }
  .switch-item-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .switch-item {
    cursor: pointer;
  }
  .active {
    color: #ff7a45;
  }
  .divider {
    width: 2px;
    height: 17px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #888;
  }
}
/* 来源 */
.source {
  .mb30;
}
/* 用户贡献度 排名 */
.rankBoard {
  width: 80%;
  display: flex;
  align-items: center;
  .mb30;
}
/* 积分排名 */
.contribute {
  padding-left: 20px;
  // margin-right: 50px;
  border-left: 3px solid #fe7b43;
}
.contribute-text {
  font-size: 18px;
  color: #4b4b4b;
}
.contribute-num {
  display: inline-block;
  width: 4em;
  margin-left: 20px;
  color: #4b4b4b;
  font-size: 20px;
  font-weight: 600;
}
/* 排名 */
.rank {
  margin-left: 30px;
}
.rank-text {
  font-size: 18px;
  color: #fe7b43;
}
.rank-num {
  margin-left: 20px;
  color: #fe7b43;
  font-size: 20px;
  font-weight: 600;
}
/* 基本信息 标题 */
.base-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 94%;
  margin: 30px auto;
  .base-title-text {
    color: #333;
    font-size: 18px !important;
    margin-left: -20px;
    font-size: 16px;
    color: #333;
  }
}
/* 用户基本信息 */
.baseInfo {
  width: 92%;
  margin: 0 auto;
}
.baseinfo-item {
  margin-bottom: 20px;
}
/* 审核 按钮 */
.verifyButton {
  display: flex;
  justify-content: center;
  width: 92%;
  margin: 30px auto;
}
.button {
  margin-left: 10px;
}
/* 用户事件 */
.userEvent {
  flex: 1;
  // background: #fff;
  //  保持宽屏时底边距统一
  .content-item;
  border: none;
  height: 100%;
}
.icard {
  margin-top: 20px;
}
.icard:last-child {
  margin-bottom: 0px;
}
.zanwuweixin {
  color: #4b4b4b;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.jifen {
  width: 60%;
  // text-align: center;
  margin-top: 30px;
  // border-left: 3px solid #ff7b44 !important;
  position: relative;
  .jf-t {
    font-size: 16px;
    color: #4b4b4b;
    margin-left: 20px;
    margin-right: 40px;
    display: inline-block;
    min-width: 64px;
  }
  .jf-c {
    font-size: 24px;
    font-weight: bold;
    color: #4b4b4b;
  }
}
.jifen::before {
  content: "";
  position: absolute;
  top: 12px;
  left: 0;
  width: 3px;
  height: 16px;
  background: #ff7b44;
}
.page {
  position: absolute;
  bottom: 0;
  width: 100%;
  // margin-top: 10px;
  display: flex;
  justify-content: center;
}
.btn_wrap {
  display: flex;
  justify-content: flex-end;
  padding: 0 0 20px 0;
}
/deep/ .ivu-card-body {
  height: 100%;
}
/deep/ .ivu-tabs {
  height: 100%;
}
/deep/ .ivu-table td.timelength {
  color: #ff7b44;
}
/deep/ .ivu-table-tip {
  overflow-x: hidden;
}
.jfbox {
  width: calc(100vw-150px-60px-392px-32px);
}
.table /deep/ table {
  width: 100% !important;
  // min-width: 875px;
}
</style>

